export default __webpack_public_path__ + "static/media/baseball-cap.e26e1f98.png";